<div *ngIf="notificationData" class="notification-wrapper" [@fade]="fadeState" (animationend)="handleAnimationEnd()">
  <img src="/assets/images/svg-icons/token.svg" alt="Token Logo" width="36" height="36" />
  <div class="d-flex flex-column content">
    <div class="d-flex align-items-center justify-content-between">
      <span>{{ notificationData.data.user | trimAddress: 4 : 4 }}</span>
      <a href="{{ notificationData.data.explorerUrl }}" target="_blank" rel="noopener noreferrer" class="link d-flex align-items-center">
        <span>View Transaction</span>
        <img src="/assets/images/svg-icons/export.svg" alt="View in Explorer" width="12" height="12" />
      </a>
    </div>
    <div class="d-flex align-items-center gap-1">
      <span>{{ txnTypes[notificationData.event] }}</span>
      <span class="value">{{ +notificationData.data.tokensBought | numberFormat }} ${{ notificationData.data.slug }}</span>
      <span>for</span>
      <span class="value">{{ +notificationData.data.amountPaid | significantDecimal }} {{ notificationData.data.chain | uppercase }}</span>
    </div>
    <div class="d-flex align-items-center justify-content-between">
      <span>{{ +notificationData.data.timestamp | timeAgo }}</span>
      <a href="https://web3paymentsolutions.io/" target="_blank" rel="noopener noreferrer" class="link">
        <img src="/assets/images/svg-icons/w3p-logo.svg" alt="Powered By Web3Payments" class="mt-2" />
      </a>
    </div>
  </div>
</div>
